
import React from 'react'
import { flowRight } from 'lodash'
import { Trans } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import './dealer-user-notification.pcss'

const DealerUserNotification = () => {
    return (
        <div className="dealer-user-notification">
            <p>
                <Trans i18nKey="common:dealerUserNotification">
                    Oma on ajoneuvokaupan ja ajoneuvotietojen hallinnoinnin palvelu yksityisille käyttäjille. Fiksut kaupat eli sähköisen ajoneuvokaupan palvelussa voi toistaiseksi tehdä vain rekisteriin merkitty ajoneuvon omistaja. Palveluun tunnistaudutaan henkilötunnuksella.
                </Trans>
            </p>
        </div>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(DealerUserNotification)
